/*
 * ceq-sticky-product-bar.js
 * Geladen von: sections/ceq-sticky-product-bar.liquid
 * Scope: Mobile Sticky-Mini-Bar — IntersectionObserver auf Hero-Element + AJAX Add-to-Cart.
 */
(function () {
  'use strict';

  const SECTIONS_TO_FETCH = ['cart-drawer', 'cart-icon-bubble'];
  const ROUTE = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  const MQ = window.matchMedia('(max-width: 989px)');

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function setVisible(bar, visible) {
    if (visible) {
      bar.dataset.state = 'visible';
      bar.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ceq-sticky-bar-active');
    } else {
      bar.dataset.state = '';
      bar.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ceq-sticky-bar-active');
    }
  }

  function attachAddHandler(bar) {
    const btn = bar.querySelector('.ceq-sticky-bar__add[data-variant-id]');
    if (!btn) return;
    const originalText = btn.textContent;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const drawer = getCartDrawer();
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (drawer) {
        formData.append('sections', SECTIONS_TO_FETCH.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      btn.disabled = true;
      btn.dataset.state = 'loading';
      btn.textContent = '…';

      fetch(ROUTE, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) throw new Error(res.description || res.message || 'Cart-Fehler');
          btn.dataset.state = '';
          btn.disabled = false;
          btn.textContent = originalText;
          if (drawer && res.sections) {
            drawer.renderContents(res);
          } else if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'ceq-sticky-product-bar',
              productVariantId: variantId,
              cartData: res,
            });
          }
        })
        .catch((err) => {
          console.error('[ceq-sticky-product-bar] add-to-cart failed', err);
          btn.dataset.state = '';
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

  function init() {
    const bar = document.querySelector('.ceq-sticky-bar');
    if (!bar) return;

    attachAddHandler(bar);

    const triggerSelector = bar.dataset.triggerSelector || '.ceq-buy-button__container';
    const trigger = document.querySelector(triggerSelector);

    function evaluate() {
      // Nur Mobile aktivieren
      if (!MQ.matches) {
        setVisible(bar, false);
        return;
      }
      if (!trigger) {
        // Kein Trigger -> Bar dauerhaft sichtbar (Fallback-Verhalten)
        setVisible(bar, true);
      }
    }

    evaluate();
    MQ.addEventListener('change', evaluate);

    if (trigger && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!MQ.matches) {
            setVisible(bar, false);
            return;
          }
          entries.forEach((entry) => {
            // Bar erscheint, sobald Trigger nicht mehr im Viewport ist
            setVisible(bar, !entry.isIntersecting);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -20% 0px' }
      );
      observer.observe(trigger);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
